import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      columns: _ctx.tabelParams.columnsTable,
      endpoint: _ctx.tabelParams.endpoint,
      headerTitle: _ctx.tabelParams.headerTitle,
      buttonTitle: _ctx.tabelParams.buttonTitle,
      editTitle: _ctx.tabelParams.editTitle,
      showColumnActivate: false,
      isEdit: false,
      isDelete: false,
      showBtnAdd: false,
      showAction: false,
      confirmDialogDelete: _ctx.tabelParams.confirmDialogDelete
    }, {
      IsActive: _withCtx(({ slotProps }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_InputSwitch, {
            modelValue: slotProps.data.IsActive,
            "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
            disabled: true
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["columns", "endpoint", "headerTitle", "buttonTitle", "editTitle", "confirmDialogDelete"])
  ]))
}